import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { toast } from 'sonner';
import { Endpoint } from '@/Config/api/endpoint';
import { ConversationAnalysisAlertsApi } from '@/Domain/api/Conversation/ConversationAnalysisAlerts.api';
import { AlertDto } from '@/Domain/api/Conversation/dto/Alert.dto';

export const useConversationAnalysisAlertDelete = () => {
  const { t } = useTranslation('insights_page');
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationKey: [`${Endpoint.conversationAnalysisAlerts.delete}-delete`],
    mutationFn: (alertId: number) => ConversationAnalysisAlertsApi.remove(alertId),
    onSuccess: (_, alertId) => {
      queryClient.setQueryData(
        [`${Endpoint.conversationAnalysisAlerts.list}-list`],
        (prev: AlertDto[] | undefined) => (prev ?? []).filter((item) => item.id !== alertId),
      );
      toast.success(t('toast.delete_alert.success'));
    },
    onError: () => {
      toast.error(t('toast.delete_alert.error'));
    },
  });

  const handleDeleteAlert = (alertId: number) => mutation.mutateAsync(alertId);

  return { handleDeleteAlert };
};
